import { action } from '@ember/object';
import { throttle } from '@ember/runloop';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import type { ImageCropData, PopupData, Service } from 'webapp-types';

import CommonImageUploadUploadComponent from 'webapp/components/common/image-upload/upload';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';

export default class CommonImageUploadPopupComponent extends PopupInnerModalComponent<PopupData.Common.ImageUpload> {
	@service('request') declare requestService: Service.Request;

	@tracked isCropActive = false;

	get popupTitle() {
		return this.isCropActive ? 'Crop image' : 'Upload image';
	}

	@action
	onCropActiveChange(isCropActive: boolean) {
		this.isCropActive = isCropActive;
	}

	@action
	onImageCrop() {
		throttle(this, this.reposition, 500);
	}

	@action
	onFinish(url: string, originalUrl: string, crop: ImageCropData | null) {
		this.popupData.onFinish(url, originalUrl, crop);
		this.onClose();
	}

	@action
	onClose() {
		this.close();
	}
	<template>
		<div class="title">
			<CommonUiIconComponent @name="Image" @size="sm" />{{this.popupTitle}}
		</div>
		<div class="content">
			<CommonImageUploadUploadComponent
				@imageOriginalUrl={{this.popupData.imageOriginalUrl}}
				@imageBlobUrl={{this.popupData.imageBlobUrl}}
				@imageCrop={{this.popupData.imageCrop}}
				@imageAspect={{this.popupData.imageAspect}}
				@onImageCrop={{this.onImageCrop}}
				@theme={{@model.theme}}
				@onFinish={{this.onFinish}}
				@onClose={{this.onClose}}
				@onCropActiveChange={{this.onCropActiveChange}}
			/>
		</div>
	</template>
}
